export default __webpack_public_path__ + "static/media/beth.29a4c2a2.jpg";